// Pure formatting for ProcessRun display in the log viewer's status bar.
// Extracted from StatusBar so the run-outcome and timestamp rules are unit-
// testable (they encode two real bugs we fixed: the soft-delete status trap and
// the double-"Z" Invalid Date).

// formatRunDate renders a continuum timestamp. continuum timestamps are tz-naive
// UTC, so we append "Z" to parse as UTC — but ONLY when the string doesn't
// already carry a zone (some query paths return a trailing Z). Bad/empty input
// passes through rather than rendering "Invalid Date".
export function formatRunDate(dateStr: string | null | undefined): string {
  if (!dateStr) return "";
  const hasZone = /[zZ]$|[+-]\d\d:?\d\d$/.test(dateStr);
  const date = new Date(hasZone ? dateStr : dateStr + "Z");
  return isNaN(date.getTime()) ? dateStr : date.toLocaleString();
}

// formatRunStatus renders a run's OUTCOME using the platform vocabulary
// (Running / Awol / Success / Failure). It must NOT use processrun.status —
// that column is the soft-delete record status (active/deleted), not the run
// result. All inputs derive from RAW columns (no joins): completedAt, the
// processComplete `kind` (which is 'awol' for a never-finished, swept run), and
// success (exitCode==0). Order matters: not-completed ⇒ Running; an awol sweep
// ⇒ Awol; otherwise the exit code decides Success vs Failure.
export function formatRunStatus(run: {
  completedAt: string | null;
  processCompleteKind?: string | null;
  success: boolean | null;
}): string {
  if (!run.completedAt) return "Running";
  if (run.processCompleteKind === "awol") return "Awol";
  if (run.success === true) return "Success";
  if (run.success === false) return "Failure";
  return "Completed"; // completed but outcome indeterminate
}
